export const ROUTES = {
  APP: 'app',
  OVERVIEW: 'overview',
  BANNERS: 'banners',
  BANNER_DETAIL: 'banner-detail',
  BANNER_DETAIL_OVERVIEW: 'banner-detail-overview',
  BANNER_DETAIL_COOKIES_TRACKERS: 'banner-detail-cookies-trackers',
  BANNER_DETAIL_APPEARANCE: 'banner-detail-appearance',
  BANNER_DETAIL_BEHAVIOUR: 'banner-detail-behaviour',
  CREATE_BANNER: 'create-banner',
  CREATE_BANNER_REGULATIONS: 'create-banner-regulations',
  CREATE_BANNER_DETAILS: 'create-banner-details',
  CREATE_BANNER_CONFIGURE: 'create-banner-configure',
  CREATE_BANNER_CREATED: 'create-banner-created',
  ANALYTICS: 'analytics',
  SETTINGS: 'settings',
  SETTINGS_ACCOUNT_DETAILS: 'settings-account-details',
  SETTINGS_ACCOUNT_MEMBERS: 'settings-account-members',
  SETTINGS_SYSTEM_SETTINGS: 'settings-system-settings',

  FAQ: 'faq',
  /** Help Center topic: /faq/:topicId */
  FAQ_TOPIC: 'faq-topic',
  /** Help Center article: /faq/:topicId/:articleId */
  FAQ_ARTICLE: 'faq-article',
  TERMS: 'terms',

  // Public pre-login landing the invite email links to.
  ACCEPT_INVITE: 'accept-invite',

  // Public pre-login landing Auth0's verification email redirects to.
  EMAIL_VERIFIED: 'email-verified',

  ERROR_POC: 'dev-errors',
}

/** Named routes that belong to the in-app Help Center (header title, drawer active). */
export const FAQ_ROUTES = [ROUTES.FAQ, ROUTES.FAQ_TOPIC, ROUTES.FAQ_ARTICLE]
